import Swal from 'sweetalert2';

export function ErrorAlert(title, message) {
  Swal.fire({
    title,
    text: message,
    icon: 'error',
  });
}
